import React = require("react");
import { truncate } from "lodash";

export interface ICardSummaryProps {
    text: string;
    maxLength: number;
}

export const CardSummary = (props: ICardSummaryProps): React.ReactElement<ICardSummaryProps> => {
    const truncatedTitle = truncate(props.text, { length: props.maxLength });
    return (
        <div className="wpo ui content table">
            <div><span>{truncatedTitle.length == 0 ? "No preview available" : truncatedTitle}</span></div>
        </div>
    );
}